import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface RelatedCaseEntry {
  slug: string;
  client: string;
  sector: string;
  highlight: string;
}

export interface RelatedCasesProps {
  title?: string;
  cases: RelatedCaseEntry[];
}

export function RelatedCases({ title, cases }: RelatedCasesProps) {
  if (cases.length === 0) return <></>;
  return (
    <section className="bg-stone-50 py-12">
      <Container>
        {title ? <h2 className="mb-6 text-2xl font-bold tracking-tightish">{title}</h2> : null}
        <div className="grid gap-4 md:grid-cols-3">
          {cases.map((c) => (
            <a
              key={c.slug}
              href={`/cas-clients/${c.slug}`}
              className="rounded-xl border border-stone-200 bg-white p-5 transition hover:border-brand-300"
            >
              <p className="text-xs font-semibold uppercase tracking-wider text-brand-700">{c.sector}</p>
              <p className="mt-1 font-display text-base font-semibold">{c.client}</p>
              <p className="mt-2 text-sm text-stone-600">{c.highlight}</p>
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
}

export const RelatedCasesConfig: ComponentConfig<RelatedCasesProps> = {
  fields: {
    title: { type: 'text' },
    cases: {
      type: 'array',
      arrayFields: {
        slug: { type: 'text' },
        client: { type: 'text' },
        sector: { type: 'text' },
        highlight: { type: 'textarea' },
      },
      defaultItemProps: { slug: '', client: '', sector: '', highlight: '' },
    },
  },
  defaultProps: { title: 'Cas clients liés', cases: [] },
  render: RelatedCases,
};
